"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KAFKA_TOPIC = exports.activityConfig = void 0;
const activity_core_1 = require("@ark/activity-core");
const utils_1 = require("@ark/utils");
exports.activityConfig = new activity_core_1.ActivityConfig({
    apiPrefix: 'mets',
    name: 'Mets',
    description: 'Mets活动包',
    businessLocations: [utils_1.BusinessLocation.US],
    // mets 的 ActFlashSaleDraw 事件经 logpipe 上抛事件中心后再分发到 Kafka，不走 KafkaProducerFactory 直投，因此不声明 kafkaProducers。
    kafkaConsumers: [
        {
            name: 'us-mets-flash-sale-draw',
            // 券商事件 ActFlashSaleDraw 经事件中心分发，topic 命名规约：q_s_<event_snake_case>
            topic: 'futu_us.raw.event.data.q_s_act_flash_sale_draw',
            cluster: 'dmp-us-broker',
            fromBeginning: false,
            activeIn: [utils_1.BusinessLocation.US],
            autoCommit: false,
            // TODO: 上线前确认事件中心已登记 topic 读取权限和 consumer group 授权。
        },
        {
            name: 'us-mets-moomoo-register',
            topic: 'plat_us.raw.event.data.create_auth',
            cluster: 'dmp-us-platform',
            fromBeginning: false,
            activeIn: [utils_1.BusinessLocation.US],
            autoCommit: false,
            // TODO: 上线前确认事件中心已登记 topic 读取权限和 consumer group 授权。
        },
    ],
});
/** Kafka topic 常量 */
exports.KAFKA_TOPIC = {
    FLASH_SALE_DRAW: 'q_s_act_flash_sale_draw',
    MOOMOO_REGISTER: 'plat_us.raw.event.data.create_auth',
};
